import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Jjdt from '../views/jingjiadating.vue'
import Jjlb from '../views/jingjialiebiao.vue'
import Jjlbxq from '../views/jjlbxiangqing.vue'
import Xtgg from '../views/xitonggonggao.vue'
import Xtggxq from '../views/xtggxiangqing.vue'
import Jjxz from '../views/jingjiaxuzhi.vue'
import Gywm from '../views/guanyuwomen.vue'
import Wcyd from '../views/wocanyude.vue'
import Jjks from '../views/jingjiakaishi.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      { path: "/", name: "index", component: () => import('@/components/Index.vue') },

      { path: "/index", name: "index", component: () => import('@/components/Index.vue') },
      {

        path: '/jjdt',
        name: 'Jjdt',
        component: Jjdt
      },
      {
        path: '/jjlb',
        name: 'Jjlb',
        component: Jjlb
      },
      {
        path: '/jjlbxq',
        name: 'Jjlbxq',
        component: Jjlbxq
      },
      {
        path: '/xtgg',
        name: 'Xtgg',
        component: Xtgg
      },
      {
        path: '/xtggxq',
        name: 'Xtggxq',
        component: Xtggxq
      },
      {
        path: '/jjxz',
        name: 'Jjxz',
        component: Jjxz
      },
      {
        path: '/gywm',
        name: 'Gywm',
        component: Gywm
      },
      {
        path: '/wcyd',
        name: 'Wcyd',
        component: Wcyd
      },
      {
        path: '/xxxg',
        name: 'xxxg',
        component: () => import('@/views/XinXiXiuGai.vue')
      },
      {
        path: '/canyu',
        name: 'canyu',
        component: () => import('@/views/wocanyude.vue')
      },
      {
        path: '/zhongbiao',
        name: 'zhongbiao',
        component: () => import('@/views/ZhongBiao.vue')
      },
      {
        path: '/jingjiagonggao',
        name: 'jingjiagonggao',
        component: () => import('@/views/JIngJiaGongGao.vue')
      },
      {
        path: '/chengjiaogonggao',
        name: 'chengjiaogonggao',
        component: () => import('@/views/ChengJiaoGongGao.vue')
      },
      {
        path: '/chengjiaodetails',
        name: 'chengjiaogonggao',
        component: () => import('@/views/chengJiaoGongGaoDetail.vue')
      },
      {
        path: '/zhengbao',
        name: 'zhengbao',
        component: () => import('@/views/jingjiakaishiZhengBao.vue')
      },
      {
        path: '/jingjiadetail',
        name: 'jingjiadetail',
        component: () => import('@/views/JingJiaDetail.vue')
      },
      {
        path: '/canyudetail',
        name: 'canyudetail',
        component: () => import('@/views/canyuDetail.vue')
      },
      {
        path: '/zhongbiaodetail',
        name: 'zhongbiaodetail',
        component: () => import('@/views/zhongbiaoDetail.vue')
      },
      {
        path: '/jjks',
        name: 'Jjks',
        component: Jjks
      }
    ]
  },
  {

    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue')
  },
  {

    path: '/resetpwd',
    name: 'login',
    component: () => import('@/views/ResetPwd.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/Register.vue')
  },
  {
    path: '/bigscreen',
    name: 'bigscreen',
    component: () => import('@/views/bigData.vue')
  },


]

const router = new VueRouter({
  mode: "history",
  routes
})
//使用push的方法
const RouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return RouterPush.call(this, to).catch(err => err)
}

//使用replace的方法
const RouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(to) {
  return RouterReplace.call(this, to).catch(err => err)
}

//挂在路由导航守卫
router.beforeEach((to, from, next) => {
  // document.title = '诚杰集团竞价平台'
  document.title = '建捷通工程竞采平台'


  //获取登录信息
  // const token = window.sessionStorage.getItem("token")
  // if (!token) {
  //   return next("/login")
  // }

  // document.title = to.meta.title || '长子县交通局轨迹监控平台'
  next()
})
export default router
